define((require) => {
    "use strict";

    var ImprovedView = require("editor/zbone/ImprovedView"),
        Backbone     = require("backbone"),
        {Logger}     = require("shared/util/Logger"),
        LoggedIn     = require("shared/security/LoggedIn"),
        template     = require("ui/experience/action/lightbox/LightboxActionPropertiesView.tpl"),
        UrlUtil      = require("shared/util/UrlUtil");

    /**
     * Properties view for a lightbox action.
     *
     * @class LightboxActionPropertiesView
     * @constructor
     *
     * @cfg {LightboxAction} model The action to display in the view.
     */
    return ImprovedView.extend({

        template: template,

        // A bit of helper info for verbose and/or ad logins...
        templateHelpers: function() {
            return {
                descriptor: Logger.level() >= Logger.VERBOSE && LoggedIn.internal() ? UrlUtil.getUrlDescriptor(this.model.get("url")) : {type: "url"}
            };
        },

        events: {
            "click .help-block .embedded": function() { // only present on valid embedded url descriptor
                var descriptor = UrlUtil.getUrlDescriptor(this.model.get("url"));
                Backbone.history.navigate("#" + descriptor.type + "/" + descriptor.id + "/edit/" + descriptor.scene, true);
            }
        },

        bindings: {
            ".lb-url":    "url",
            ".lb-height": "height",
            ".lb-width":  "width"
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/lightbox/LightboxActionPropertiesView.js